const b = ["#e5b3c5", "#d7779e", "#a73b84", "#631c6d"], c = ["#e5b3c5", "#d7779e", "#bf5991", "#a73b84", "#631c6d"], _ = [
  "#e5b3c5",
  "#e49ab8",
  "#d7779e",
  "#bf5991",
  "#bf5991",
  "#631c6d"
];
export {
  b as TRAFFIC_VOLUME_WINE_4,
  c as TRAFFIC_VOLUME_WINE_5,
  _ as TRAFFIC_VOLUME_WINE_6
};
//# sourceMappingURL=index.es5679.js.map
